import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { FC, useEffect, useState } from "react";
import { modalDownloads } from "../../../atoms/atom";
import { FormService } from "../../../services/FormService";
import { useAlert } from "../../contextProviders/AlertProvider";
import { getDownload } from "../info-form-modal/InfoFormModal";
import './ModalDownloads.scss';

const ModalDownloads: FC = () => {
	const [open, setOpen] = useAtom(modalDownloads);
	const [downloads, setDownloads] = useState<string[]>([]);
	const service = new FormService();
	const { showError } = useAlert();

	useEffect(() => {
		const fetchDownloads = async () => {
			try {
				const response = await service.getAvailableDownloads();
				if (response) {
					setDownloads(response.data);
				}
			} catch (error) {
				console.error('Erro ao obter os downloads disponíveis', error);
			}
		};
		if (open) {
			fetchDownloads();
			const interval = setInterval(() => {
				if (open) {
					fetchDownloads();
				}
			}, 5000);
			return () => {
				clearInterval(interval);
			};
		}
	}, [open]);

	const handleDownload = async (filename: string) => {
		try {
			const response = await service.downloadFile(filename);
			getDownload(response, filename);
		} catch (error) {
			showError('Erro ao baixar o arquivo');
		}
	};

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			className='modal-downloads'
		>
			<DialogTitle>Downloads</DialogTitle>
			<DialogContent id="modal-downloads-content">
				<Box sx={{width: '100%', padding: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 2}}>
					{downloads.map((download) => (
						<Box key={download} sx={{border: '1px solid #ccc', borderRadius: 1, padding: 2, width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
							<Typography variant="body1">{download}</Typography>
							<Button onClick={() => handleDownload(download)}>Baixar</Button>
						</Box>
					))}
					{downloads.length === 0
						? <Typography variant="body1">Nenhum download disponível no momento. Quando seu arquivo estiver pronto, ele ficará disponível aqui.</Typography>
						: <></>
					}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button id="close-form-button" onClick={() => setOpen(false)}>
					Fechar
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ModalDownloads;